import React from "react";
import LegalLayout, { Section, Highlight } from "./LegalLayout";
import { LEGAL } from "./legalInfo";

export default function Privacidad() {
    return (
        <LegalLayout
            title="Aviso de Privacidad"
            intro={
                <Highlight>
                    <p className="font-semibold text-white mb-1">En resumen</p>
                    <p>
                        {LEGAL.marca}.mx provee <strong>únicamente la interfaz</strong> para la venta de
                        boletos. Lo relacionado con el evento, los pagos y los reembolsos es responsabilidad
                        del <strong>Organizador</strong>. {LEGAL.marca}.mx es responsable del{" "}
                        <strong>uso legal y la protección de tu información personal</strong> conforme a este
                        Aviso.
                    </p>
                </Highlight>
            }
        >
            <Section n={1} title="Identidad y domicilio del responsable">
                <p>
                    {LEGAL.razonSocial}, en lo sucesivo “{LEGAL.marca}”, con domicilio en {LEGAL.domicilio},
                    RFC {LEGAL.rfc} y correo de contacto{" "}
                    <a className="text-brand hover:underline" href={`mailto:${LEGAL.correoPrivacidad}`}>{LEGAL.correoPrivacidad}</a>,
                    es el <strong>responsable</strong> del tratamiento de sus datos personales, en términos de
                    la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (la “Ley”)
                    y su normativa aplicable.
                </p>
                <p>
                    {LEGAL.marca} opera la plataforma disponible en{" "}
                    <a className="text-brand hover:underline" href={LEGAL.sitio}>{LEGAL.sitio}</a>{" "}
                    (el “Sitio”), mediante la cual se comercializan boletos para eventos organizados por terceros.
                </p>
            </Section>

            <Section n={2} title="Naturaleza de Monoticket y alcance de este Aviso">
                <p>
                    {LEGAL.marca}.mx es una <strong>plataforma tecnológica que provee la interfaz</strong> para
                    operar la taquilla de eventos por cuenta de los <strong>Organizadores</strong>.{" "}
                    {LEGAL.marca}.mx <strong>no custodia ni administra dinero ajeno</strong>: los pagos se
                    procesan a través de <strong>Stripe</strong> y se depositan directamente en la cuenta de
                    Stripe del Organizador. Lo relacionado con la compra, reembolsos y aspectos económicos del
                    evento es responsabilidad del Organizador; {LEGAL.marca}.mx es responsable del{" "}
                    <strong>uso legal de la información personal</strong>.
                </p>
                <p>Este Aviso aplica a:</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Compradores y usuarios del Sitio que adquieren boletos.</li>
                    <li>Organizadores que contratan los servicios de {LEGAL.marca}.</li>
                    <li>Visitantes del Sitio.</li>
                </ul>
            </Section>

            <Section n={3} title="Datos personales que recabamos">
                <p className="font-semibold text-white">De compradores y usuarios:</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Datos de identificación y contacto: nombre, correo electrónico, número telefónico y tu <strong>identificador de usuario</strong> en la plataforma.</li>
                    <li>Datos de facturación: RFC, razón social, domicilio fiscal, uso de CFDI (cuando solicite factura).</li>
                    <li>Datos de la transacción: eventos y boletos adquiridos, fecha, monto.</li>
                </ul>
                <p className="font-semibold text-white mt-3">Cuando inicias sesión con Google (Google Sign-In):</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Al usar “Iniciar sesión con Google”, recibimos de tu cuenta de Google, mediante su servicio de autenticación, tu <strong>nombre</strong> (nombre y apellido), tu <strong>correo electrónico</strong>, el <strong>identificador de tu cuenta de Google</strong> (ID de usuario) y la confirmación de que tu correo está verificado.</li>
                    <li>Usamos esos datos únicamente para <strong>crear tu cuenta e iniciar tu sesión</strong>, y guardamos tu nombre y correo asociados a tu cuenta. <strong>No</strong> recibimos ni almacenamos tu contraseña de Google.</li>
                </ul>
                <p className="font-semibold text-white mt-3">De Organizadores:</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Datos de identificación del negocio y de la persona de contacto.</li>
                    <li>Datos fiscales (RFC, razón social, domicilio).</li>
                    <li>Identificador de la cuenta de Stripe vinculada.</li>
                </ul>
                <p className="font-semibold text-white mt-3">De forma automática (todos los usuarios):</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Datos técnicos y de navegación: dirección IP, tipo de dispositivo y navegador, páginas visitadas y cookies (ver sección 9).</li>
                </ul>
                <div className="mt-3 rounded-xl border border-white/10 bg-white/5 p-3 text-gray-300">
                    <strong>Datos de pago (tarjetas).</strong> Los datos de su tarjeta o medio de pago son
                    capturados y procesados directamente por <strong>Stripe</strong>, cumpliendo el estándar
                    PCI-DSS. {LEGAL.marca}.mx <strong>no almacena</strong> los números completos de tarjeta.
                </div>
            </Section>

            <Section n={4} title="Datos personales sensibles">
                <p>
                    {LEGAL.marca}.mx <strong>no recaba datos personales sensibles</strong> (como origen racial,
                    estado de salud, creencias, preferencias sexuales, datos biométricos, entre otros) para la
                    operación ordinaria del servicio. En caso de que algún evento requiera recabarlos, se
                    solicitará su consentimiento expreso y por escrito mediante un aviso específico.
                </p>
            </Section>

            <Section n={5} title="Finalidades del tratamiento">
                <p className="font-semibold text-white">Finalidades primarias (necesarias para el servicio)</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Crear y administrar tu cuenta y autenticarte, incluido el inicio de sesión con Google (Google Sign-In).</li>
                    <li>Procesar la compra de boletos y entregar su boleto digital (incluyendo código QR).</li>
                    <li>Gestionar el acceso al evento y validar boletos.</li>
                    <li>Emitir comprobantes y facturas (CFDI) cuando corresponda.</li>
                    <li>Brindar atención y soporte al cliente.</li>
                    <li>Prevenir fraudes y garantizar la seguridad de la plataforma.</li>
                    <li>Cumplir obligaciones legales y requerimientos de autoridad.</li>
                    <li>Para Organizadores: operar la taquilla, conciliar ventas y liquidar pagos a través de Stripe.</li>
                </ul>
                <p className="font-semibold text-white mt-3">Finalidades secundarias (no necesarias)</p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>Enviarle comunicaciones promocionales sobre eventos y novedades de {LEGAL.marca}.</li>
                    <li>Realizar encuestas de satisfacción y análisis estadístico para mejorar el servicio.</li>
                </ul>
                <p className="mt-2">
                    Si <strong>no desea</strong> que sus datos se traten para las finalidades secundarias, puede
                    manifestarlo enviando un correo a{" "}
                    <a className="text-brand hover:underline" href={`mailto:${LEGAL.correoPrivacidad}`}>{LEGAL.correoPrivacidad}</a>.
                    Su negativa no será motivo para negarle los servicios.
                </p>
            </Section>

            <Section n={6} title="Transferencias de datos personales">
                <p>
                    Sus datos podrán ser transferidos a los siguientes terceros, en los casos y para los fines
                    que se indican. De conformidad con la Ley, algunas transferencias <strong>no requieren su
                    consentimiento</strong> por ser necesarias para la relación jurídica o por mandato legal:
                </p>
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm border border-white/10 rounded-lg overflow-hidden">
                        <thead className="bg-white/5 text-white">
                            <tr>
                                <th className="p-2 border-b border-white/10">Destinatario</th>
                                <th className="p-2 border-b border-white/10">Finalidad</th>
                                <th className="p-2 border-b border-white/10">¿Consentimiento?</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-300">
                            <tr>
                                <td className="p-2 border-b border-white/10"><strong>Organizador del evento</strong></td>
                                <td className="p-2 border-b border-white/10">Acceso, gestión y, en su caso, atención y reembolsos del evento adquirido</td>
                                <td className="p-2 border-b border-white/10">No (necesaria para la relación jurídica)</td>
                            </tr>
                            <tr>
                                <td className="p-2 border-b border-white/10"><strong>Stripe, Inc. (EE. UU.)</strong></td>
                                <td className="p-2 border-b border-white/10">Procesamiento de pagos. Implica transferencia internacional</td>
                                <td className="p-2 border-b border-white/10">No (necesaria para ejecutar la transacción)</td>
                            </tr>
                            <tr>
                                <td className="p-2 border-b border-white/10"><strong>Google LLC (EE. UU.)</strong></td>
                                <td className="p-2 border-b border-white/10">Inicio de sesión con Google (Google Sign-In): autenticación de tu cuenta. Implica transferencia internacional</td>
                                <td className="p-2 border-b border-white/10">No (necesaria para autenticarte, a petición tuya)</td>
                            </tr>
                            <tr>
                                <td className="p-2 border-b border-white/10"><strong>Autoridades competentes</strong></td>
                                <td className="p-2 border-b border-white/10">Cumplimiento de obligaciones legales y requerimientos</td>
                                <td className="p-2 border-b border-white/10">No (mandato legal)</td>
                            </tr>
                            <tr>
                                <td className="p-2 border-b border-white/10"><strong>Proveedores tecnológicos</strong> (hosting, facturación, mensajería)</td>
                                <td className="p-2 border-b border-white/10">Operación del servicio bajo encargo de {LEGAL.marca}</td>
                                <td className="p-2 border-b border-white/10">No (encargados del tratamiento)</td>
                            </tr>
                            <tr>
                                <td className="p-2">Terceros con fines distintos a los anteriores</td>
                                <td className="p-2">Según se requiera</td>
                                <td className="p-2"><strong>Sí, consentimiento expreso</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p className="mt-2">Salvo las anteriores, no compartiremos sus datos con terceros sin su consentimiento.</p>
            </Section>

            <Section n={7} title="Derechos ARCO y revocación del consentimiento">
                <p>
                    Usted tiene derecho a <strong>Acceder, Rectificar, Cancelar u Oponerse</strong> (derechos
                    ARCO) al tratamiento de sus datos, así como a <strong>revocar el consentimiento</strong> que
                    nos haya otorgado. Para ejercerlos, envíe una solicitud al correo{" "}
                    <a className="text-brand hover:underline" href={`mailto:${LEGAL.correoPrivacidad}`}>{LEGAL.correoPrivacidad}</a>{" "}
                    indicando:
                </p>
                <ol className="list-decimal pl-5 space-y-1">
                    <li>Nombre completo y medio para recibir la respuesta.</li>
                    <li>Documento que acredite su identidad (o representación legal).</li>
                    <li>Descripción clara de los datos y del derecho que desea ejercer.</li>
                    <li>Cualquier elemento que facilite la localización de los datos.</li>
                </ol>
                <p>
                    Daremos respuesta en los plazos establecidos por la Ley. La revocación del consentimiento o
                    la cancelación de ciertos datos podría impedirnos seguir prestándole el servicio.
                </p>
            </Section>

            <Section n={8} title="Limitación del uso y divulgación">
                <p>
                    Puede solicitar limitar el uso o divulgación de sus datos enviando su solicitud al correo de
                    contacto. Asimismo, puede inscribirse en los registros para evitar publicidad que establezca
                    la autoridad competente y la PROFECO (REPEP), cuando aplique.
                </p>
            </Section>

            <Section n={9} title="Uso de cookies y tecnologías de rastreo">
                <p>
                    El Sitio utiliza <strong>cookies</strong> y tecnologías similares para mejorar su
                    experiencia, recordar preferencias, mantener su sesión y obtener estadísticas de uso. Puede
                    deshabilitar las cookies desde la configuración de su navegador, considerando que algunas
                    funciones del Sitio podrían verse afectadas.
                </p>
            </Section>

            <Section n={10} title="Seguridad de la información">
                <p>
                    {LEGAL.marca}.mx implementa medidas de seguridad administrativas, técnicas y físicas
                    razonables para proteger sus datos contra daño, pérdida, alteración, destrucción o uso/acceso
                    no autorizado. En caso de una vulneración relevante a su seguridad, lo notificaremos conforme
                    a la Ley.
                </p>
            </Section>

            <Section n={11} title="Cambios al Aviso de Privacidad">
                <p>
                    Nos reservamos el derecho de modificar este Aviso. Cualquier cambio será publicado en{" "}
                    <a className="text-brand hover:underline" href={`${LEGAL.sitio}/privacidad`}>{LEGAL.sitio}/privacidad</a>,
                    indicando la fecha de la última actualización. Le recomendamos revisarlo periódicamente.
                </p>
            </Section>

            <Section n={12} title="Autoridad competente">
                <p>
                    Si considera que su derecho a la protección de datos ha sido vulnerado, puede acudir ante la
                    autoridad competente en materia de protección de datos personales conforme a la legislación
                    vigente.
                </p>
            </Section>

            <Section n={13} title="Contacto">
                <p>
                    Para cualquier duda sobre este Aviso de Privacidad, escríbanos a:<br />
                    Correo: <a className="text-brand hover:underline" href={`mailto:${LEGAL.correoPrivacidad}`}>{LEGAL.correoPrivacidad}</a><br />
                    Domicilio: {LEGAL.domicilio}
                </p>
            </Section>
        </LegalLayout>
    );
}
